import React, { PropTypes } from "react";

import { NitroHeading, NitroNavBar, NitroText } from "nitro-components";

import styled from "styled-components";

const TopTitleContainer = styled.div`
position:absolute;
width:100%;
margin-left:-20px;
top:0px;
text-align:${props => props.align};
padding:25px;
height:70px;
background-color: ${props => props.theme.color.secondary};
`;

const HeaderTitle = styled.div`
position:relative;
text-align:center;
padding-left:20px;
padding-right:20px;
width:70%;
margin-top:4px;
margin-left: auto;
margin-right: auto;
`;

const SidePanelHeader = ({ drilldownTitle, drillUp, rootTitle, stickToTop }) =>
  (drilldownTitle
    ? <div>
        <TopTitleContainer>
          <NitroNavBar
            size="4"
            noPadding
            headerSize="3"
            headerVariant="white"
            arrowVariant="white"
            drillDownEllipsis
            label={drilldownTitle}
            action={drillUp}
            headerOpacity={0.5}
            arrowSize={16}
          />
        </TopTitleContainer>
        <HeaderTitle>
          <NitroText variant="white" size="15" bold>{rootTitle}</NitroText>
        </HeaderTitle>

        {/* invisible spacer to resolve text bleeding */}
        <div style={{ height: 60 }} />
      </div>
    : <div>
        {/*<NitroHeading label={rootTitle} size="2" variant="secondary" noMargin /> */}
        <TopTitleContainer align="center">
          <NitroText variant="white" size="15" bold>{rootTitle}</NitroText>
        </TopTitleContainer>
        <div style={{ height: 70 }} />
      </div>);

export default SidePanelHeader;

SidePanelHeader.defaultProps = {
  stickToTop: true
};

SidePanelHeader.propTypes = {
  drilldownTitle: PropTypes.string,
  drillUp: PropTypes.func,
  rootTitle: PropTypes.string.isRequired,
  stickToTop: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/components/factoryComponents/SidePanelHeader.js